<ngx-spinner *ngIf="spinnerActiveuser != false" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
  type="ball-clip-rotate-multiple" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner>
<ngx-spinner *ngIf="spinnerActiveadduser != false" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
  type="ball-clip-rotate-multiple" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner>

<ngx-spinner *ngIf="spinnerActiveablockuser != false" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
  type="ball-clip-rotate-multiple" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner>

  <div class="container-fluid pt-4" (scroll)="onWindowScroll($event)" [ngStyle]="{'display': hiddenContenu === 'true' ? '' :'none'}"
    style="margin-bottom: 500px">
    <div class="row" style="display: flex;align-items: center;">
      <div class="col-xl-4 col-md-12 col-lg-12 w-100">
        <p class="m-0 text-uppercase"
        style="font-size: 20px;color: #262756;font-weight: bold;">Liste des Utilisateurs</p>
        <small class="text-uppercase"
        style="font-size:15px;color: #959090;"> Utilisateurs</small>
      </div>
    </div>
    <div class="col-lg-12 col-xl-3 col-md-12 w-100 pl-0">
      <div>
      </div>
    </div>
    <div class="row w-100 m-0 mb-2">
      <div class="col-2">
        <div class="export-icons d-flex mb-2"style="margin-top: 12%;">
          <div class="icn-sec">
            <img (click)="exportExcel(exportDirective, 'xlsx')" src="assets/newImages/excel-svg.svg"
              ngbTooltip="Expoter EXCEL" />
          </div>
          <div class="icn-sec">
            <img (click)="exportTable()" src="assets/newImages/pdf-svg.svg" ngbTooltip="Expoter PDF" />
          </div>
        </div>
      </div>
      <div class="col-xl-5  w-100">
      </div>
      <div class="col-xl-5 col-md-12 col-lg-12  pr-0  w-100">
        <div class="row  px-3 w-100 " style="    display: flex;
        justify-content: flex-end;margin-top: 3.5% ;padding-right: 0px !important;">
          <div class="col-md-9 w-100  " style="display: grid;">
            <mat-form-field class="example-full-width">
              <mat-label>Chercher par nom d'utilisateur</mat-label>
              <input matInput [(ngModel)]="value" (keyup)="getOeuvresByTaskId()" mdInput id="searchInput" #Input
                type="text">
              <button class="fa" mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear"
                (click)="clearValue()">
                <mat-icon style=" font-size: x-large;">close</mat-icon>
              </button>
              <button (click)="refrechdata()" mat-button matSuffix mat-icon-button class="mr-4" placement="bottom"
                ngbTooltip="Actualiser">
                <mat-icon style=" font-size: x-large;color: #3b5876;">refresh</mat-icon>

              </button>

            </mat-form-field>
          </div>

          <div (click)="add(addUser)"
          style="
            height: 40px;
            margin-top: 10px;
            display: flex;
            justify-content: space-around;
            align-items: center;" placement="bottom" ngbTooltip="Ajouter utilisateur">
            <img src="assets/icons/add-utilisateur.svg" alt="">
          </div>
        </div>
      </div>
    </div>
    <hr>
  <div [ngClass]="{'overflow': listAdmin.length> 8}" (scroll)="onWindowScroll($event)">
    <div class="row py-3">
      <div *ngFor="let user of listAdmin" class="col-md-12 col-lg-6 col-xl-3 px-3 mb-4 example-1 card">
        <div class="wrapper" >
          <div class="absolute">
            <ul class="menu-content" style="margin-top: 42%">
              <li *ngIf="user.is_active == 1">
                <a (click)="blockUser(user)" placement="top" ngbTooltip="Bloquer utilisateur">
                  <img src="assets/icons/block.svg" alt="">
                </a>
              </li>
              <li *ngIf="user.is_active != 1">
                <a (click)="unblockUser(user)" class="fas fa-lock-open" placement="top"
                  ngbTooltip="Débloquer utilisateur"></a>
              </li>
              <li (click)="edit(user)">
                <a placement="top" ngbTooltip="Modifier utilisateur">
                  <img src="assets/icons/edit.svg" alt="">
                </a>
              </li>
              <li> <a (click)="deleteUser(user)" placement="top" ngbTooltip="Supprimer utilisateur">
                  <img src="assets/icons/delete.svg" alt="">
                </a>
              </li>
            </ul>
          </div>
          <div *ngIf="user.is_active == 1" class="example-pusle"
          style="z-index: 5555;
              position: absolute;
              margin-left: 61%;
              margin-top: 7%;"
            [ngStyle]="{'background-color':user.is_active != 1 ? '#ea5455' : '#81b214' }" placement="left"
            ngbTooltip="Utilisateur actif"> </div>
          <div *ngIf="user.is_active != 1" class="example-pusle"
          style="z-index: 5555;
              position: absolute;
              margin-left: 61%;
              margin-top: 7%;"
            [ngStyle]="{'background-color':user.is_active != 1 ? '#ea5455' : '#81b214' }" placement="left"
            ngbTooltip="Utilisateur bloqué"> </div>
          <img *ngIf="user.is_admin===0" (click)="hiddenContenuall(user)"
            src="assets/icons/user-avatar.svg"  class="positionImage" placement="top"
            ngbTooltip="Cliquer pour modifier utilisateur {{user.username}}" />
          <img *ngIf="user.is_admin===1" (click)="hiddenContenuall(user)"
            src="assets/icons/admin-avatar.svg" class="positionImage"   placement="top"
            ngbTooltip="Cliquer pour modifier utilisateur {{user.username}}" />
          <div style="text-align: center;">
              <h1 style="
              margin-top: 1.5%;
              font-size: 20px;
              color: #262756;font-weight: bold;">{{user.username}}</h1>
              <small *ngIf="user.is_admin===1"
              style="margin-top: 0%;
              font-size: 12px;
              cursor: pointer;">
                Administrateur
              </small>
              <small *ngIf="user.is_admin===0"
                style= "margin-top: 0%;
                  font-size: 12px;
                  cursor: pointer;">
                  Utilisateur
              </small>
          </div>
          <hr style="border: 1px solid #e8e4e4; margin-top: 3%;width: 72%;">
          <div style="margin-left: 23%;">
            <h1 class="der-connexion"> Dernière connexion </h1>
            <p class="myp"> {{user?.last_login}}</p>
          </div>
          <div style="margin-left: 23%;">
            <h1 class="date-exper"> Date d'expiration </h1>
            <p class="mysencodP">{{user?.expiration_date}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  </div>

  <table #exportDirective="matTableExporter" matTableExporter id="ExampleTable" mat-table [dataSource]="listAdmin"
    class="mat-elevation-z8 d-none ">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="is_admin">
      <th mat-header-cell *matHeaderCellDef> Statut </th>
      <td mat-cell *matCellDef="let element"> {{element.is_admin}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="last_name">
      <th mat-header-cell *matHeaderCellDef> Nom </th>
      <td mat-cell *matCellDef="let element"> {{element.last_name}} </td>
    </ng-container>


    <!-- Weight Column -->
    <ng-container matColumnDef="first_name">
      <th mat-header-cell *matHeaderCellDef> Prénom </th>

      <td mat-cell *matCellDef="let element"> {{element.first_name}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef> Utilisateur </th>
      <td mat-cell *matCellDef="let element"> {{element.username}} </td>
    </ng-container>
    <!-- Symbol Column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>
    <!-- Symbol Column -->
    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef> Date de création </th>
      <td mat-cell *matCellDef="let element"> {{element.created_at}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="last_login">
      <th mat-header-cell *matHeaderCellDef> Dernière connexion </th>
      <td mat-cell *matCellDef="let element"> {{element.last_login}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="expiration_date">
      <th mat-header-cell *matHeaderCellDef> Date d'expiration </th>
      <td mat-cell *matCellDef="let element"> {{element.expiration_date}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="is_active">
      <th mat-header-cell *matHeaderCellDef> Activé </th>
      <td mat-cell *matCellDef="let element"> {{element.is_active}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div class="container-fluid py-4  " [ngStyle]="{'display': hiddenContenu === 'false' ? '' :'none'}">
  <!-- ici les formulaire  -->
  <div class="row">
    <div class="col-md-12 w-100 mb-4">

      <div class="row    ">
        <div class="col-md-10 w-100  ">

          <p class="m-0 text-uppercase" style="font-size: 20px;
            color: #237dbd;" *ngIf="useraddform=='true'"> Modifier Utilisateur {{itemsSelected?.email}} </p>
          <p class="m-0 text-uppercase" style="font-size: 20px;
            color: #237dbd;" *ngIf="useraddform=='false'"> ajouter Utilisateur</p>
          <small (click)="hiddenContenuUser()" class="text-uppercase" style="font-size:15px ;    display: flex;
          align-items: center;cursor: pointer;">
            <mat-icon>keyboard_backspace</mat-icon> Utilisateurs
          </small>

        </div>

        <div class="col-md-2 " style="    display: flex;
            justify-content: flex-end;
            align-items: center;
            padding-right: 8px;

        ">
          <button mat-button [matMenuTriggerFor]="menu">

            <mat-icon><svg width="30" fill="#3b5876" viewBox="0
                  0 49 32" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0292969
                    0.0818024H48.8773V5.40163H0.0292969V0.0818024ZM48.8773
                    13.3814H20.0125V18.7012H48.8773V13.3814ZM48.8773
                    26.6806H8.91086V32H48.8773V26.6806Z" />
              </svg>
            </mat-icon>

          </button>
          <mat-menu #menu="matMenu">
            <button (click)="hiddenContenuUser()" mat-menu-item class="text-uppercase"><i class="fas fa-users mr-1"
                style="font-size:17px"></i> Listes des Utilisateurs</button>
            <button (click)="hiddenContenuall2()" mat-menu-item class="text-uppercase"
              [ngClass]="{'iconColor':  useraddform==='false' }"><i class="fas fa-user-plus mr-1"
                style="font-size:17px"></i> ajouter Utilisateur</button>
          </mat-menu>
        </div>

      </div>

    </div>

    <!-- <div *ngIf="useraddform=='false'" class="col-md-6 w-100" [formGroup]="registerForm" (submit)="submitForm()">

      <h3 class="p-2">
        <img src="https://img.icons8.com/fluent/30/000000/bookmark-ribbon.png" />
        Nom de compte
      </h3>


      <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
        <mat-label>Nom de compte </mat-label>
        <input formControlName="username" #input matInput placeholder="" class="inputModal"
          [errorStateMatcher]="matcher" required>
        <mat-error *ngIf="registerForm.controls['username'].invalid" class="elhoo_compte_messageErrorPositionModal">
          Nom de compte est <strong>obligatoire</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
        <mat-label>E-Mail</mat-label>
        <input matInput formControlName="email" matInput placeholder="" class="inputModal"
          [errorStateMatcher]="matcher">
        <mat-icon matSuffix>alternate_email</mat-icon>

        <mat-error *ngIf="registerForm.get('email').hasError('email')">Veuillez saisir une format valide !
        </mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="useraddform=='false'" class="col-md-6 w-100" [formGroup]="registerForm" (submit)="submitForm()">

      <h3 class="p-2">
        <img src="https://img.icons8.com/fluent/30/000000/new-contact.png" />
        Informations sur contact
      </h3>

      <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
        <mat-label>Prénom</mat-label>
        <input matInput formControlName="first_name" placeholder="" class="inputModal" [errorStateMatcher]="matcher">
      </mat-form-field>

      <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
        <mat-label>Nom</mat-label>
        <input matInput formControlName="last_name" type="text" class="inputModal" [errorStateMatcher]="matcher"
          required>
        <mat-error *ngIf="registerForm.controls['last_name'].invalid" class="elhoo_compte_messageErrorPositionModal">
          Nom est <strong>obligatoire</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
        <mat-label>Téléphone</mat-label>
        <input maxlength="15" type="tel" matInput formControlName="gsm_number" placeholder="" class="inputModal">
        <mat-icon matSuffix>perm_phone_msg</mat-icon>
        <mat-error *ngIf="registerForm.controls['gsm_number'].invalid" class="elhoo_compte_messageErrorPositionModal">
          Téléphone est <strong>obligatoire</strong>
        </mat-error>
      </mat-form-field>






    </div>


    <div *ngIf="useraddform=='false'" class="col-md-6 w-100" [formGroup]="registerForm" (submit)="submitForm()">

      <h3 class="p-2">
        <img src="https://img.icons8.com/fluent/30/000000/geography.png" />
        Localisation
      </h3>
      <mat-form-field appearance="fill" class="w-100 mb-3">
        <mat-label>Sélectionner Pays </mat-label>
        <mat-select formControlName="country" class="inputModal" (selectionChange)="onChangeCountry()">

          <mat-option *ngFor="let country of countryInfo; let i = index" [value]="i">
            {{country.CountryName}}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="fill" class="w-100 mb-3">
        <mat-label>Sélectionner Ville </mat-label>


        <mat-select formControlName="city" class="inputModal">

          <mat-option *ngFor="let state of stateInfo; let j = index" [value]="j">{{state.StateName}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="fill" class="w-100 mb-3">
        <mat-label>Sélectionner Langue</mat-label>
        <mat-select disableRipple formControlName="lang" class="inputModal">
          <mat-option [value]="0">Francais</mat-option>
          <mat-option [value]="1">Anglais</mat-option>
          <mat-option [value]="2">Espagnol</mat-option>
        </mat-select>
      </mat-form-field>


    </div>

    <div class="col-md-4 w-100 d-none">

      <h3 class="p-2 ">
        <img src="https://img.icons8.com/color/30/000000/user-folder.png" />
        Droits disponibles Admin
      </h3>
      <section class="example-section">
        <span class="example-list-section">
          <mat-checkbox class="example-margin" [checked]="allComplete" [indeterminate]="someComplete()"
            (change)="setAll($event.checked)">
            {{task.name}}
          </mat-checkbox>
        </span>
        <span class="example-list-section">
          <ul>
            <li *ngFor="let subtask of task.subtasks">
              <mat-checkbox [(ngModel)]="subtask.completed" [color]="subtask.color"
                (ngModelChange)="updateAllComplete()">
                {{subtask.name}}
              </mat-checkbox>
            </li>
          </ul>
        </span>
      </section>


    </div>
    <div class="col-md-4 w-100 d-none">
      <h3 class="p-2">
        <img src="https://img.icons8.com/color/30/000000/user-folder.png" />
        Droits disponibles Basic
      </h3>
      <section class="example-section">
        <span class="example-list-section">
          <mat-checkbox class="example-margin" [checked]="allComplete2" [indeterminate]="someComplete2()"
            (change)="setAll2($event.checked)">
            {{task2.name}}
          </mat-checkbox>
        </span>
        <span class="example-list-section">
          <ul>
            <li *ngFor="let subtask of task2.subtasks">
              <mat-checkbox [(ngModel)]="subtask.completed" [color]="subtask.color"
                (ngModelChange)="updateAllComplete2()">
                {{subtask.name}}
              </mat-checkbox>
            </li>
          </ul>
        </span>
      </section>


    </div>
    <div class="col-md-4 w-100 d-none d-none">

      <h3 class="p-2">
        <img src="https://img.icons8.com/color/30/000000/user-folder.png" />
        Droits disponibles Rapport
      </h3>
      <section class="example-section">
        <span class="example-list-section">
          <mat-checkbox class="example-margin" [checked]="allComplete3" [indeterminate]="someComplete3()"
            (change)="setAll3($event.checked)">
            {{task3.name}}
          </mat-checkbox>
        </span>
        <span class="example-list-section">
          <ul>
            <li *ngFor="let subtask of task3.subtasks">
              <mat-checkbox [(ngModel)]="subtask.completed" [color]="subtask.color"
                (ngModelChange)="updateAllComplete3()">
                {{subtask.name}}
              </mat-checkbox>
            </li>
          </ul>
        </span>
      </section>


    </div>

    <div *ngIf="useraddform=='false'" class="col-md-6 w-100" [formGroup]="registerForm" (submit)="submitForm()">
      <h3 class="p-2">
        <img src="https://img.icons8.com/dusk/30/000000/show-password.png" />
        Mot de passe
      </h3>


      <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
        <mat-label>Mot de passe</mat-label>
        <input #motdepasseajouter minlength="10" maxlength="15" matInput formControlName="password"
          [type]="hide ? 'password' : 'text'" id="password" placeholder="" class="inputModal"
          [errorStateMatcher]="matcher" required placeholder="***************">
        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon style="color: #3b5876;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-hint align="start" style="color: green;">Mot de passe entre 10 et 15 caractères</mat-hint>
        <mat-hint align="end" style="color: green;">{{motdepasseajouter.value.length}} / 15</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
        <mat-label>Confirmation du mot de passe</mat-label>
        <input minlength="10" maxlength="15" formControlName="passwordConfirm" placeholder="" class="inputModal"
          id="passwordConfirm" [errorStateMatcher]="matcher" [type]="hide2 ? 'password' : 'text'" matInput required
          placeholder="***************">
        <button mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide2">
          <mat-icon style="color: #3b5876;">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>


        <mat-error *ngIf="registerForm.get('passwordConfirm').hasError('confirmedValidator')" class="error-txt">Les mots
          de passe doivent être identiques.</mat-error>
      </mat-form-field>


    </div>

    <div *ngIf="useraddform=='false'" class="col-md-6 w-100" [formGroup]="registerForm" (submit)="submitForm()">
      <h3 class="p-2">
        <img src="https://img.icons8.com/color/30/000000/restriction-shield.png" />
        Accès
      </h3>

      <mat-form-field color="accent" appearance="fill" class="w-100 mb-3">
        <mat-label>Date d'expiration</mat-label>
        <input matInput [matDatepicker]="picker1" formControlName="expiration_date" class="inputModal">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <mat-radio-group *ngIf="itemsSelected !=null" aria-labelledby="example-radio-group-label"
        formControlName="is_active">
        <mat-radio-button [value]="0" [checked]="is_active != 1" class="mb-1">Bloquer</mat-radio-button> <br>
        <mat-radio-button [value]="1" [checked]="is_active == 1">Débloquer</mat-radio-button>
      </mat-radio-group>

    </div>

    <div class="col-md-12 w-100">
      <div class=" justify-content-center d-flex mt-3">

        <a *ngIf="useraddform=='false' && !registerForm.valid" class="btn text-uppercase mr-2" type="submit"
          aria-pressed="true" [ngClass]="{'disabled': !registerForm.valid }">Enregistrer</a>
        <a *ngIf="useraddform=='false' && registerForm.valid" class="btn text-uppercase mr-2" type="submit"
          aria-pressed="true" (click)="submitForm()">Enregistrer</a>
        <a *ngIf="useraddform=='false'" (click)="hiddenContenuUser()" class="btn text-uppercase" type="submit"
          aria-pressed="true">Annuler</a>
      </div>
    </div> -->

    <!-- modification  -->
    <!-- fin de modification -->
  </div>
  </div>
<!-- p dialog  -->
<ng-template #addUser>
  <h2 class="modal-title" style="margin-top: 3%; margin-left: 65px; font-weight: bold;">
     AJouter utilisateur
  </h2>
  <hr style="
    border: 1px solid #262756;
    opacity: 0.23;
    top: 247px;
    left: 442px;
    width: 1035px;
    height: 0px;
  " />
  <div class="container-fluid mt-3" style="width: 93%;">
    <form class="mt-4" [formGroup]="registerForm" (submit)="submitForm()">
      <div class="row">
        <div class="col-5 col-md-5 w-100">
          <h1 class="mytitle">
            Nom de compte</h1>
            <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
              <mat-label>Nom de compte </mat-label>
              <input formControlName="username" #input matInput placeholder="" class="inputModal"
                [errorStateMatcher]="matcher" required>
              <mat-error *ngIf="registerForm.controls['username'].invalid" class="elhoo_compte_messageErrorPositionModal">
                Nom de compte est <strong>obligatoire</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
              <mat-label>E-Mail</mat-label>
              <input matInput formControlName="email" matInput placeholder="" class="inputModal"
                [errorStateMatcher]="matcher">
              <mat-error *ngIf="registerForm.get('email').hasError('email')">Veuillez saisir une format valide !
              </mat-error>
            </mat-form-field>
        </div>
        <div class="col-1 col-md-1 w-100"></div>
        <div class="col-5 col-md-5 w-100">
          <h1 class="mytitle">
            Informations de contact
          </h1>
          <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
            <mat-label>Prénom</mat-label>
            <input matInput formControlName="first_name" placeholder="" class="inputModal" [errorStateMatcher]="matcher">
          </mat-form-field>

          <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
            <mat-label>Nom</mat-label>
            <input matInput formControlName="last_name" type="text" class="inputModal" [errorStateMatcher]="matcher"
              required>
            <mat-error *ngIf="registerForm.controls['last_name'].invalid" class="elhoo_compte_messageErrorPositionModal">
              Nom est <strong>obligatoire</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
            <mat-label>Téléphone</mat-label>
            <input maxlength="15" type="tel" matInput formControlName="gsm_number" placeholder="" class="inputModal">
            <mat-error *ngIf="registerForm.controls['gsm_number'].invalid" class="elhoo_compte_messageErrorPositionModal">
              Téléphone est <strong>obligatoire</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-5 col-md-5 w-100">
          <h1 class="mytitle">
            Localisation </h1>
            <mat-form-field appearance="fill" class="w-100 mb-3">
              <mat-label>Sélectionner Pays </mat-label>
              <mat-select formControlName="country" class="inputModal" (selectionChange)="onChangeCountry()">

                <mat-option *ngFor="let country of countryInfo; let i = index" [value]="i">
                  {{country.CountryName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-100 mb-3">
              <mat-label>Sélectionner Ville </mat-label>


              <mat-select formControlName="city" class="inputModal">

                <mat-option *ngFor="let state of stateInfo; let j = index" [value]="j">{{state.StateName}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-100 mb-3">
              <mat-label>Sélectionner Langue</mat-label>
              <mat-select disableRipple formControlName="lang" class="inputModal">
                <mat-option [value]="0">Francais</mat-option>
                <mat-option [value]="1">Anglais</mat-option>
                <mat-option [value]="2">Espagnol</mat-option>
              </mat-select>
            </mat-form-field>
        </div>
        <div class="col-1 col-md-1 w-100"></div>
        <div class="col-5 col-md-5 w-100">
          <h1 class="mytitle">
            Mot de passe</h1>
            <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
              <mat-label>Mot de passe</mat-label>
              <input #motdepasseajouter minlength="10" maxlength="15" matInput formControlName="password"
                [type]="hide ? 'password' : 'text'" id="password" placeholder="" class="inputModal"
                [errorStateMatcher]="matcher" required placeholder="***************">
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                <mat-icon style="color: #3b5876;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-hint align="start" style="color: green;">Mot de passe entre 10 et 15 caractères</mat-hint>
              <mat-hint align="end" style="color: green;">{{motdepasseajouter.value.length}} / 15</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
              <mat-label>Confirmation du mot de passe</mat-label>
              <input minlength="10" maxlength="15" formControlName="passwordConfirm" placeholder="" class="inputModal"
                id="passwordConfirm" [errorStateMatcher]="matcher" [type]="hide2 ? 'password' : 'text'" matInput required
                placeholder="***************">
              <button mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide2">
                <mat-icon style="color: #3b5876;">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>


              <mat-error *ngIf="registerForm.get('passwordConfirm').hasError('confirmedValidator')" class="error-txt">Les mots
                de passe doivent être identiques.</mat-error>
            </mat-form-field>
        </div>
     </div>
     <div class="row">
       <div class="col-5 col-md-5 w-100">
         <h1 class="mytitle">Accès</h1>
         <mat-form-field color="accent" appearance="fill" class="w-100 mb-3">
          <mat-label>Date d'expiration</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="expiration_date" class="inputModal">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <mat-radio-group *ngIf="itemsSelected !=null" aria-labelledby="example-radio-group-label"
          formControlName="is_active">
          <mat-radio-button [value]="0" [checked]="is_active != 1" class="mb-1">Bloquer</mat-radio-button> <br>
          <mat-radio-button [value]="1" [checked]="is_active == 1">Débloquer</mat-radio-button>
        </mat-radio-group>

       </div>
     </div>
    </form>
  </div>
  <div class=" justify-content-end d-flex" style=" margin-right: 5%; margin-bottom: 40px;">
    <!-- <a  class="btn text-uppercase mr-2" type="submit"
      aria-pressed="true" [ngClass]="{'disabled': !registerForm.valid }">Enregistrer</a> -->
    <a class="savebtn mr-2" type="submit"
      aria-pressed="true" (click)="submitForm()"matDialogClose>Enregistrer</a>
    <a class="cancelbtn" type="button"matDialogClose
      aria-pressed="true">Annuler</a>
  </div>
</ng-template>
